<template>
  <div class="container">
    <div class="detailsbox">
      <h2 class="detailstitle">{{details.title}}</h2>
      <span class="detailstime">{{details.noteTime}}</span>
      <div class="detailsconbox">
        <div class="detailscon" v-html="details.content"></div>
        <!-- <div class="qrcodebox" style="display: none;" id="qrcode" ref="qrcode"></div> -->
        <!-- 添加一个新的div，用来展示 canvas 转换的 base64 图片 -->
        <!-- <div class="qrcodebox">
            <img :src="qrcodeimg" alt="" v-show="qrcodeimg">
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  data(){
    return{
      id:"",
      details:"",
      isQrcode:false,
      qrcodeimg:"",
    }
  },
  methods:{
    getData(){
      this.axios.get(`/note/tz/${this.id}`).then(res=>{
        this.details = res.data
        if(this.details.ewm){
          this.$nextTick(()=>{
            this.isQrcode = true
            // this.changeQrcode()
          })
        }
        this.$nextTick(()=>{
          var pArr = document.getElementsByTagName("p")
          pArr = Array.from(pArr);
          for(var item of pArr){
            item.setAttribute("style","text-indent:2em")
          }
        })
      })
      
    },
    changeQrcode(){
      let that = this
      var cal_arr = document.getElementById("qrcode").getElementsByTagName("img")
      cal_arr = Array.from(cal_arr);
      cal_arr.forEach(item => {
        if (item.nodeName.toLowerCase() === 'img') {//我的数据返回是可以
          document.getElementById("qrcode").removeChild(item)
        }
      })
      this.$nextTick(() => {
        this.qrcode = new QRCode("qrcode", {
          width: 200,//二维码宽度
          height: 200,//二维码高度
          text: that.details.ewm,//调用微信支付接口返回的微信特殊链接：例如"weixin://wxpay/bizpayurl?pr=uDKsQ4E00"
          colorDark: "#000",//颜色配置
          colorLight: "#fff",
        });
        // 生成二维码之后，获取canvas元素
        let qrcodeEle = document.getElementById("qrcode")
        let cvs = qrcodeEle.querySelector('canvas')
        this.qrcodeimg = cvs.toDataURL('image/png')
      });
    },
  },
  created(){
    this.id = this.$route.query.id
  },
  mounted(){
    this.getData()
  },
}
</script>

<style src="@/assets/css/css.css" scoped></style>
<style scoped>
</style>